import { Col, Form, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import FormClienteOrigemDestino from './FormClienteOrigemDestino';
import { GlobalStyle, Steps } from './styles';

const { Step } = Steps;

export default function ClienteOrigemDestino({
  currentStep,
  form,
  dadosLote,
  disableField,
  isMarketplace,
}) {
  const steps = [
    {
      title: 'Remetente',
      content: (
        <FormClienteOrigemDestino
          tipoCliente="Origem"
          title="1. Remetente*"
          required={true}
          form={form}
          dadosLote={dadosLote}
          disableField={disableField || !isMarketplace}
          enderecoDisabled={true}
          enderecoCompletoRequired={false}
        />
      ),
    },
    {
      title: 'Destinatário',
      content: (
        <FormClienteOrigemDestino
          tipoCliente="Destino"
          title="2. Destinatário*"
          required={true}
          form={form}
          dadosLote={dadosLote}
          disableField={disableField || !isMarketplace}
          enderecoDisabled={true}
          enderecoCompletoRequired={false}
        />
      ),
    },
    {
      title: 'Expedidor',
      content: (
        <FormClienteOrigemDestino
          tipoCliente="Expedidor"
          clienteCopy="Origem"
          title="3. Expedidor"
          form={form}
          dadosLote={dadosLote}
          disableField={disableField || !isMarketplace}
          required={true}
          enderecoDisabled={false}
          enderecoCompletoRequired={true}
        />
      ),
    },
    {
      title: 'Recebedor',
      content: (
        <FormClienteOrigemDestino
          tipoCliente="Recebedor"
          clienteCopy="Destino"
          title="4. Recebedor"
          form={form}
          dadosLote={dadosLote}
          disableField={disableField || !isMarketplace}
          enderecoDisabled={true}
          enderecoCompletoRequired={false}
        />
      ),
    },
  ];

  return (
    <>
      <GlobalStyle />
      <Row>
        <Col span={18} offset={4}>
          <Steps
            current={currentStep}
            labelPlacement="vertical"
            size="small"
            className="customSteps"
          >
            {steps.map(item => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
        </Col>
      </Row>

      {steps.map((item, index) => (
        <Form.Item
          key={item.title}
          className={`steps-content ${index !== currentStep && 'hidden'}`}
        >
          {item.content}
        </Form.Item>
      ))}
    </>
  );
}

ClienteOrigemDestino.propTypes = {
  currentStep: PropTypes.number.isRequired,
  form: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  ).isRequired,
  disableField: PropTypes.bool.isRequired,
  isMarketplace: PropTypes.bool.isRequired,
  dadosLote: PropTypes.objectOf(PropTypes.any).isRequired,
};
